<template>
    <v-app id="sammio">
      <div id="announcer" class="sr-only" aria-live="polite"></div>
      <sammio-loader :load-done="getLoadStatus" :is-loading="getLoaderStatus" v-if="getLoaderStatus"></sammio-loader>
      <sammio-header></sammio-header>
      <sammio-footer v-if="getIsMobile"></sammio-footer>
      <section id="content" class="container-fluid">
        <div id="main-content" role="main">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </section>
      <a href="#" id="yjaScrollToTop" onclick="jQuery('html').focus();">
	    <span role="presentation" class="icon-circle-arrow-up mr-1"></span>
	    <span>{{$t('sammio.page_top')}}</span>
	  </a>
    </v-app>
</template>

<script>

    import SammioHeader from './components/SammioHeader.vue'
    import SammioLoader from './components/SammioLoader.vue'
    import SammioFooter from './components/SammioFooter'

    import { mapGetters } from 'vuex'

    export default {
        components: {
            sammioHeader: SammioHeader,
            sammioLoader: SammioLoader,
            sammioFooter: SammioFooter
        },
        beforeDestroy () {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        created() {
            this.$store.dispatch('initPortletId', this.$root.portletId)
        },
        mounted () {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        computed: {
          ...mapGetters([
                'getLoaderStatus',
                'getLoadStatus',
                'getIsMobile'
              ])
        },
        methods: {
            onResize () {
                if ( window.innerWidth < 912 ) {
                    this.$store.dispatch('setIsMobile', true)
                } else {
                    this.$store.dispatch('setIsMobile', false)
                }
            }
        }
    }

</script>
